import * as React from "react"
import { Flex } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { SkeletonProps } from "./skeleton.intarface"

export const BadgeSkeleton: React.FC<SkeletonProps> = ({
  containerProps,
  offFade,
  isSmallView
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <Flex
      padding="0.5rem"
      border="2px solid"
      borderRadius="0.5rem"
      width={isSmallView && "100%"}
      borderColor={roomStyles?.servicePanelElementBorder ?? "#E2E8F0"}
      background={roomStyles?.servicePanelElementBackground ?? "white"}
      style={{ ...containerProps }}
    >
      <Flex
        marginTop="auto"
        marginBottom="auto"
        height={isSmallView ? "65px" : "75px"}
        width={isSmallView ? "80px" : "100px"}
        backgroundColor={"#687786"}
      />
      <Flex flexDirection="column" marginLeft="18px" width="100%">
        <Flex
          height="8px"
          width="75px"
          backgroundColor={"#687786"}
          marginTop={isSmallView ? "5px" : "10px"}
          marginBottom="10px"
        />
        <Flex
          height="8px"
          width="150px"
          backgroundColor={"#687786"}
          marginBottom={!isSmallView && "10px"}
        />
        {!isSmallView && (
          <Flex height="8px" width="150px" backgroundColor={"#687786"} />
        )}
        <Flex marginTop={isSmallView ? "8px" : "18px"} alignItems="center">
          <Flex height="8px" width="60px" backgroundColor={"#687786"} />
          <Flex
            height={isSmallView ? "20px" : "32px"}
            borderRadius="0.375rem"
            width="50px"
            marginLeft="auto"
            backgroundColor={"#687786"}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}
